import styled from 'styled-components';
import { ToastContainer } from 'react-toastify';
import { bodySmall2, poppinsMediumFont } from '@/styles/typography';
import { COLORS } from '@/styles/colors';
import { resetButton } from '@/styles/common';
import './animation.css';

// We only use this breakpoint for snackbar design, since our mobile breakpoint(768px) is too wide for it.
const SNACKBAR_MOBILE_BREAKPOINT = '480px';

export const StyledSnackbar = styled(ToastContainer).attrs({
  className: 'wv-snackbar',
})`
  &.Toastify__toast-container {
    top: 32px;
    right: 32px;

    @media only screen and (max-width: ${SNACKBAR_MOBILE_BREAKPOINT}) {
      width: auto;
      top: 20px;
      left: 16px;
      right: 16px;
    }
  }

  .Toastify__toast {
    max-width: 360px;
    background-color: ${COLORS.grey[900]};
    color: ${COLORS.grey[300]};
    border-radius: 12px;
    padding: 13px 60px 15px 20px;
    ${poppinsMediumFont};
    ${bodySmall2};
    overflow: hidden;
    width: auto;

    @media only screen and (max-width: ${SNACKBAR_MOBILE_BREAKPOINT}) {
      max-width: none;
      margin-bottom: 12px;
    }
  }

  .Toastify__toast-icon {
    width: 26px;
    margin-right: 16px;
  }

  .Toastify__progress-bar--error {
    background: linear-gradient(90deg, ${COLORS.red[400]} -0.62%, rgb(227 65 76 / 25%) 108.89%);
  }

  .Toastify__progress-bar--success {
    background: linear-gradient(90deg, ${COLORS.green[400]} 0.92%, rgb(1 146 102 / 25%) 107.47%);
  }

  .Toastify__progress-bar {
    right: 40px;
    width: auto;
  }
`;

export const CloseButtonWrapper = styled.button`
  ${resetButton};
  padding: 10px;
  background-color: ${COLORS.grey[850]};
  cursor: pointer;
  position: absolute;
  height: 100%;
  top: 0;
  right: 0;
`;
